<script>
import { mapState, mapActions } from 'vuex';
/* components */
import TransactionsTable from '@/components/TransactionsTable';
import Balance from '@/components/Balance';
import Pagination from '@/components/Pagination';
/* tools */
import { applyLanguage } from '@/scripts/language';
import { getTransactions } from '@/scripts/api/transactions';
import { wsConnection } from '@/scripts/modules/ws';
import { getBalances } from '@/scripts/api/account';
import { rushBalance } from '@/scripts/computed';
import { qrCodeMockImage } from '@/scripts/constants/constants';
import { setPagesCount } from '@/scripts/methods';

export default {
  name: 'Wallet',
  components: {
    Balance,
    TransactionsTable,
    Pagination,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: null,
      page: 1,
      pages: 0,
      /*  */
      showAccordion: {},
      depositAddressValue: '0xf23e23b1123FE647f5Cd9a7315A7C6c622A58884',
    };
  },
  watch: {
    page(page) {
      this.updateTransactions(page);
    },
  },
  computed: {
    ...mapState(['user', 'balances']),
    rushBalance,
  },
  created() {
    this.updateBalance();
    this.updateTransactions();

    this.qrCodeMockImage = qrCodeMockImage;

    /* ws */
    wsConnection.setCallback('wallets.balancesUpdate', () => {
      this.updateBalance();
      this.updateTransactions();
    });
  },
  mounted() {},
  destroyed() {
    wsConnection.removeCallback('wallets.balancesUpdate');
  },
  methods: {
    ...mapActions({ setBalances: 'setBalances' }),
    updateBalance() {
      return getBalances().then(this.setBalances);
    },
    updateTransactions(page = this.page) {
      const props = { page };

      return getTransactions(props).then(data => {
        const { items } = data;
        this.items = items;
        this.setPagesCount(data);
      });
    },
    toggleShow(token, field) {
      this.$set(
        this.showAccordion,
        token,
        this.showAccordion[token] === field ? null : field
      );
    },
    /* copyToClipboard() {
      const { depositAddressValue } = this;

      copyToClipboard(depositAddressValue);
    }, */
    applyLanguage,
    setPagesCount,
  },
};
</script>

<template>
  <div>
    <div class="wallet">
      <div class="wallet__content">
        <!-- head page -->
        <div class="wallet__row wallet__row--head">
          <div class="wallet__title">{{ applyLanguage('wallet', 'Menu') }}</div>
          <div class="wallet__balance">
            <!-- balance -->
            <Balance />
          </div>
        </div>

        <!-- tokens -->
        <!-- TODO: next release -->
        <!-- v-for="(amount, token) in balances" -->
        <div
          v-for="(hidden, token) in null"
          :key="token"
          class="wallet__row wallet__row--table-wallet"
        >
          <div class="list">
            <div class="list__item">
              <div class="coin-block">
                <div
                  :class="{
                    'coin-block__row': true,
                    'is-active': showAccordion[token],
                  }"
                >
                  <div class="coin-block__left">
                    <div class="coin">
                      <div class="coin__img">
                        <img :src="require('@/assets/svg/dollar.svg')" />
                      </div>
                      <div class="coin__content">
                        <div class="coin__title">{{ token }}</div>
                        <div class="coin__subtitle">{{ token }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="coin-block__right">
                    <div class="coin-block__item">
                      <div class="coin-block__label">Balance</div>
                      <div class="coin-block__value">
                        {{ amount }} <span>{{ token }}</span>
                      </div>
                    </div>
                    <div class="coin-block__item">
                      <!-- buttons deposit and withdraw -->
                      <div class="list-btn">
                        <div class="list-btn__item">
                          <button
                            :class="{
                              'btn-icon': true,
                              'is-active': showAccordion[token] === 'deposit',
                            }"
                            @click="toggleShow(token, 'deposit')"
                          >
                            <div class="btn-icon__img">
                              <img :src="require(`@/assets/svg/deposit.svg`)" />
                            </div>
                            <span>Deposit</span>
                          </button>
                        </div>
                        <div class="list-btn__item">
                          <button
                            :class="{
                              'btn-icon': true,
                              'is-active': showAccordion[token] === 'withdraw',
                            }"
                            @click="toggleShow(token, 'withdraw')"
                          >
                            <div class="btn-icon__img">
                              <img
                                :src="require(`@/assets/svg/withdraw.svg`)"
                              />
                            </div>
                            <span>Withdraw</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Withdraw row -->
                <div
                  class="coin-block__info"
                  v-show="showAccordion[token] === 'withdraw'"
                >
                  <div class="info">
                    <div
                      class="info__close"
                      @click="showAccordion[token] = null"
                    >
                      <img :src="require(`@/assets/svg/close-white.svg`)" />
                    </div>
                    <div class="info__title">Withdraw</div>
                    <div class="info__action">
                      <div class="info__item info__item--sm">
                        <div class="input-block">
                          <div class="input-block__label">Amount:</div>
                          <div class="input-block__wrapper">
                            <!--  -->
                            <input
                              type="text"
                              class="input input--coin"
                              placeholder="Enter withdraw amount"
                            />
                            <div class="input-block__coin">RUSH</div>
                          </div>
                          <div class="input-block__counter">Min 1 RUSH</div>
                        </div>
                      </div>
                      <div class="info__item info__item--lg">
                        <div class="input-block">
                          <div class="input-block__label">
                            Wallet Address:
                          </div>
                          <div
                            class="input-block__wrapper input-block__wrapper--textarea"
                          >
                            <textarea
                              type="text"
                              class="input"
                              placeholder="Paste your address here"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="info__item info__item--button">
                        <button class="btn">Withdraw</button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- // -->

                <!-- deposit row -->
                <div
                  class="coin-block__info"
                  v-show="showAccordion[token] === 'deposit'"
                >
                  <div class="info info--deposit">
                    <div
                      class="info__close"
                      @click="showAccordion[token] = null"
                    >
                      <img :src="require(`@/assets/svg/close-white.svg`)" />
                    </div>
                    <div class="info__title">Deposit</div>
                    <div class="info__action">
                      <div class="info__item info__item--qr-code">
                        <!-- TODO: qr code -->
                        <!-- test code img-->
                        <img :src="qrCodeMockImage" alt="" />
                      </div>
                      <div class="info__item info__item--lg">
                        <div class="input-block">
                          <div class="input-block__label">
                            Deposit Address:
                          </div>
                          <div class="input-block__wrapper">
                            <!--  -->
                            <input
                              type="text"
                              class="input"
                              :value="depositAddressValue"
                            />

                            <!-- wtf -->
                            <!-- <button class="copy" @click="copyToClipboard">
                            Copy
                          </button> -->
                          </div>
                        </div>
                      </div>
                      <div class="info__item info__item--button">
                        <!--  -->
                        <button class="btn">Generate New address</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- // -->

        <!-- transtion table -->
        <div class="wallet__row wallet__row--table-transition">
          <TransactionsTable :tableBody="items" />
        </div>

        <!-- Pagination -->
        <div class="wallet__row wallet__row--pagination">
          <Pagination :page="page" :pages="pages" @set-page="n => (page = n)" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.wallet {
  &__content {
    padding: 30px 30px 100px 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
  }

  &__row {
    width: 100%;

    &--head {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &--table-wallet {
      margin-top: 30px;
    }

    &--table-transition {
      margin-top: 50px;
    }

    &--pagination {
      margin-top: 50px;
    }
  }

  &__title {
    font-family: Poppins-Light;
    font-size: 36px;
    line-height: 51px;
    color: #ffffff;
  }
}

.list-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  &__item {
    & + & {
      margin-left: 10px;
    }
  }
}

.info {
  width: 100%;
  background: #232e33;
  color: #ffffff;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 25px 20px 24px;
  min-height: 128px;
  position: relative;

  &--deposit {
    padding: 22px 20px;
  }

  &__action {
    display: flex;
    align-items: flex-end;
    width: 100%;
  }

  &__close {
    position: absolute;
    top: 15px;
    right: 18px;
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
  }

  &__item {
    & + & {
      margin-left: 20px;
    }

    & + &--button {
      margin-left: 30px;
    }

    &--qr-code + & {
      margin-left: 25px;
    }

    &--sm {
      width: 286px;
      flex-shrink: 0;
    }

    &--lg {
      flex-grow: 1;
    }

    &--button {
      flex-shrink: 0;
    }

    &--qr-code {
      width: 84px;
      height: 84px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        display: flex;
        width: 100%;
        height: 100%;
      }
    }
  }

  &__title {
    width: 100%;
    font-family: Poppins-Regular;
    font-size: 18px;
    line-height: 25px;
    color: #fff;
    text-align: center;
    display: none;
  }
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border-radius: 12px;
  background: #4e7cff;
  border: 0;
  min-height: 44px;
  min-width: 190px;
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  text-transform: capitalize;
  padding: 5px 10px;
  text-align: center;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background: rgba(78, 124, 255, 0.5);
  }
}

.btn-icon {
  outline: none;
  border-radius: 12px;
  border: solid 1px rgba(0, 184, 249, 0.3);
  background: transparent;
  min-width: 98px;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 8px;
  transition: all 0.2s;
  cursor: pointer;

  &__img {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;

    img {
      display: flex;
      width: 15px;
      height: 15px;
    }
  }

  span {
    font-family: Poppins-Regular;
    font-size: 10px;
    line-height: 12px;
    color: #ffffff;
    margin-top: 5px;
    flex-shrink: 0;
  }

  &.is-active,
  &:hover {
    background: rgba(0, 184, 249, 0.1);
    border-color: rgba(0, 184, 249, 0.1);
  }
}

.coin {
  display: flex;
  align-items: center;

  &__img {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 12px;
    border: solid 1px rgba(255, 255, 255, 0.2);
    background-color: rgba(255, 255, 255, 0.1);
    overflow: hidden;

    img {
      display: flex;
      width: 32px;
      height: 32px;
    }
  }

  &__content {
    margin-left: 15px;
  }

  &__title {
    font-family: Poppins-Medium;
    font-size: 16px;
    line-height: 23px;
    color: #ffffff;
    text-transform: uppercase;
  }

  &__subtitle {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.7);
    text-transform: uppercase;
    margin-top: 4px;
  }
}

.input-block {
  width: 100%;
  position: relative;

  &__label {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }

  &__wrapper {
    width: 100%;
    margin-top: 15px;
    position: relative;
    display: flex;

    textarea {
      line-height: 27px;
    }
  }

  &__counter {
    position: absolute;
    right: 0;
    top: 0;
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.3);
  }

  &__coin {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

.input {
  height: 44px;
  border-radius: 8px;
  border: solid 1px rgba(255, 255, 255, 0.2);
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  padding: 8px 10px;
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 17px;
  outline: none;
  width: 100%;

  &.disabled-points {
    user-select: none;
    pointer-events: none;
  }

  &:placeholder {
    height: inherit;
    line-height: inherit;
  }

  &--coin {
    padding-right: 50px;
  }
}

.list {
  width: 100%;

  &__item {
    & + & {
      margin-top: 15px;
    }
  }
}

.coin-block {
  width: 100%;

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 80px;
    padding: 10px 15px;
    border-radius: 12px;
    background-color: #232e33;

    &.is-active {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      box-shadow: 0 20px 40px 0 rgba(8, 7, 16, 0.5);
      position: relative;
      z-index: 1;
    }
  }

  &__right {
    display: flex;
    margin-left: 15px;
    text-align: right;
    align-items: center;
  }

  &__item {
    & + & {
      margin-left: 50px;
    }
  }

  &__label {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 3px;
  }

  &__value {
    font-family: Poppins-Regular;
    font-size: 18px;
    line-height: 25px;
    color: #ffffff;
  }
}

.copy {
  border: 0;
  border-radius: 12px;
  background-color: rgba(255, 193, 7, 0.1);
  min-height: 36px;
  height: 36px;
  min-width: 93px;
  outline: none;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 20px;
  color: #ffc107;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(255, 193, 7, 0.3);
  }
}

@media (max-width: $mobile) {
  .wallet {
    &__content {
      padding: 20px 15px 80px;
    }

    &__title {
      font-size: 21px;
      line-height: 29px;
    }

    &__row {
      &--head {
        align-items: flex-start;
      }

      &--pagination {
        margin-top: 40px;
      }
    }
  }

  .list {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__item {
      width: 100%;
      max-width: 340px;
    }
  }

  .coin-block {
    max-width: 340px;

    &__row {
      align-items: flex-start;
      flex-direction: column;
      border-radius: 16px;
      padding: 0;

      &.is-active {
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        box-shadow: none;
      }
    }

    &__left {
      padding: 15px 15px 0;
      width: 100%;
    }

    &__right {
      margin-left: 0;
      margin-top: 20px;
      text-align: left;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
    }

    &__label {
      font-size: 12px;
      line-height: 17px;
      color: rgba(255, 255, 255, 0.4);
      margin-bottom: 10px;
    }

    &__value {
      font-size: 16px;
      line-height: 23px;
    }

    &__item {
      padding: 0 15px;
      width: 100%;

      & + & {
        margin-left: 0;
        margin-top: 20px;
        padding: 0;
        background: #1d2629;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
      }
    }
  }

  .list-btn {
    justify-content: center;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    &__item {
      width: 50%;

      & + & {
        margin-left: -1px;
        border-left: 1px solid rgba(255, 255, 255, 0.1);
      }
    }
  }

  .btn-icon {
    border-radius: 0;
    border: 0;
    flex-direction: row;
    min-height: 51px;
    width: 100%;

    &__img {
      width: 23px;
      height: 23px;
      flex-grow: initial;
      margin-right: 15px;

      img {
        width: 23px;
        height: 23px;
      }
    }

    span {
      margin-top: 0;
      font-size: 12px;
      line-height: 15px;
    }

    &.is-active,
    &:hover {
      background: transparent;
      border-color: transparent;
    }
  }

  .coin {
    align-items: flex-start;
  }

  .info {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    z-index: 10;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 25px 15px 30px;
    overflow-y: auto;
    background-color: #090909;

    &__action {
      flex-direction: column;
      align-items: center;
      flex-grow: 1;
    }

    &__title {
      display: block;
      flex-shrink: 0;
      margin-bottom: 30px;
    }

    &__item {
      max-width: 290px;
      width: 100%;

      & + & {
        margin-top: 30px;
        margin-left: 0;
      }

      &--button {
        display: flex;
        flex-grow: 1;
        align-items: flex-end;
        justify-content: center;

        .btn {
          width: 100%;
        }
      }

      &--qr-code {
        width: 260px;
        height: 260px;
      }
    }

    &__close {
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 20px;
      right: 20px;

      img {
        display: flex;
        width: 100%;
        height: 100%;
      }
    }
  }

  .input-block {
    &__label {
      font-size: 12px;
      line-height: 17px;
      color: rgba(255, 255, 255, 0.7);
    }

    &__wrapper {
      display: flex;
      align-self: center;

      .copy {
        flex-shrink: 0;
        margin-left: 15px;
      }

      &--textarea {
        textarea {
          display: block;
          resize: none;
          height: 88px;
          padding-top: 12px;
          line-height: 17px;

          &:placeholder {
            line-height: 100%;
          }
        }
      }
    }
  }

  .copy {
    width: 44px;
    height: 44px;
    min-width: auto;
    border-radius: 8px;
    border: solid 1px rgba(255, 193, 7, 0.2);
    background-color: rgba(255, 193, 7, 0.1);
    font-size: 0;
    flex-shrink: 0;
    position: relative;

    &:hover {
      background-color: rgba(255, 193, 7, 0.1);
    }

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 15px;
      height: 16px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      background-image: url('~@/assets/svg/copy.svg');
    }
  }
}
</style>
